<template>
  <div class="joinUs-page">
    <div class="public-banner bg-cover">
      <div class="absolute center text-center color-white">
        <h1>加入我们</h1>
        <p class="English">Join Us</p>
      </div>
    </div>
    <div class="container">
      <ul class="type-list">
        <li v-for="(item, index) in typeList" :key="index" class="vertical-middle select-point" :class="{ active: item.value == activeIndex }" @click="clickType(item.value)">
          {{ item.label }}
        </li>
      </ul>
      <ul class="main-list">
        <li v-for="(item, index) in listData" :key="index" class="display-flex-between flex-align-end" @click="selectItem = item; toggleDetail(true)">
          <div class="left-part">
            <p class="name">{{ item.jobName }}</p>
            <p class="type">
              <span>全职</span>社会招聘
            </p>
            <p class="address">{{ item.address || '广东·深圳市' }}</p>
          </div>
          <span class="time">发布时间：{{ item.time || '-' }}</span>
        </li>
      </ul>
    </div>
    <div class="popup-wrap flex-center" v-show="detailFlag">
      <span class="bg" @click="toggleDetail(false)"></span>
      <div class="detail-box">
        <div class="display-flex-between flex-align-end">
          <div class="left-part">
            <p class="name">{{ selectItem.jobName }}</p>
            <p class="type">
              <span>全职</span>社会招聘
            </p>
            <p class="address">{{ selectItem.address || '广东·深圳市' }}</p>
          </div>
          <span class="time">发布时间：{{ selectItem.time || '-' }}</span>
        </div>
        <div class="content">
          <div v-for="item in selectItem.jobDescription">
            <p class="title">{{ item.name }}</p>
            <ul>
              <li v-for="item2 in item.value">
                {{ item2 }}
              </li>
            </ul>
          </div>
        </div>
        <a class="btn normal-btn" href="mailto:hr@tanwuapp.com" data-text="立即投递"></a>
        <img class="popup-close" src="~@assets/img/popup-close.png" @click="toggleDetail(false)">
      </div>
    </div>
  </div>
</template>

<script>
import websitejob from '@/assets/json/websitejob.json'
// import websitejob1 from '@/assets/json/websitejob1.json'
// import websitejob2 from '@/assets/json/websitejob2.json'
// import websitejob3 from '@/assets/json/websitejob3.json'
// import websitejob4 from '@/assets/json/websitejob4.json'
import Vue from 'vue'
import { CONFIG, network } from '@assets/js/apis';
export default {
  data() {
    return {
      websitejob: websitejob,
      // websitejob1: websitejob1,
      // websitejob2: websitejob2,
      // websitejob3: websitejob3,
      // websitejob4: websitejob4,
      activeIndex: 0,
      typeList: [
        {
          label: '全部岗位', value: 0
        },
        {
          label: '运营岗位', value: 1
        },
        {
          label: '产研岗位', value: 2
        },
        {
          label: '风控岗位', value: 3
        },
        {
          label: '职能岗位', value: 4
        },
        {
          label: '一线部门岗位', value: 5
        }
      ],
      listData: [],
      detailFlag: false,
      selectItem: {},
      timeList: ['2026.03.12', '2026.03.01', '2026.03.08', '2026.03.10']
    }
  },
  created() {
    // network(CONFIG.joinUs).then(res => {
    // let details = this.websitejob.list || [];
    // details.map((item, index) => {
    //   item.time = this.timeList[index] || this.timeList[0];
    // })
    // this.listData = details;
    // });
    this.clickType(0)
  },
  methods: {
    clickType(type = 0) {
      switch (type) {
        case 0:
          this.listData = [...this.websitejob.list, ...this.websitejob.list1, ...this.websitejob.list2, ...this.websitejob.list3, ...this.websitejob.list4]
          break
        case 1:
          this.listData = this.websitejob.list
          break
        case 2:
          this.listData = this.websitejob.list1
          break
        case 3:
          this.listData = this.websitejob.list2
          break
        case 4:
          this.listData = this.websitejob.list3
          break
        case 5:
          this.listData = this.websitejob.list4
          break
      }
      this.activeIndex = type
    },
    toggleDetail(type) {
      let body = document.querySelector('body');
      body.style.overflow = type ? 'hidden' : 'auto';
      this.detailFlag = type;
    }
  }
}
</script>

<style lang="scss">
.joinUs-page {
  // min-height: 1000px;
  min-height: calc(100vh - 400px);

  .public-banner {
    background-image: url('https://resource.tanwuapp.com/FtB9NVM3HoL_-X76OP3S64PEO5hS');
  }

  .time {
    font-size: 14px;
    color: #999;
  }

  .type {
    font-size: 14px;
    color: #999;

    >span {
      position: relative;
      padding-right: 25px;

      &::after {
        content: '';
        position: absolute;
        height: 14px;
        width: 1px;
        background: #DDDDDD;
        top: 50%;
        transform: translateY(-50%);
        right: 13px;
      }
    }
  }

  .address {
    font-size: 14px;
    color: #333;
    margin-top: 10px;
  }

  .main-list {
    border-top: 1px solid #EEEEEE;
    line-height: 1.4285;
    padding-top: 40px;
    padding-bottom: 80px;

    li {
      padding: 24px 0;
      border-bottom: 1px solid #EEEEEE;
      cursor: pointer;

      .name {
        font-size: 18px;
        line-height: 1.38888;
        font-weight: bold;
        margin-bottom: 10px;
        transition: color 0.2s;
      }

      .left-part,
      .time {
        transition: transform 0.3s;
      }

      &:hover {
        .left-part {
          transform: translateX(20px);
        }

        .time {
          transform: translateX(-20px);
        }

        .name {
          color: #3ED8C4;
        }
      }
    }
  }

  .detail-box {
    box-sizing: border-box;
    padding: 50px 80px;
    position: relative;
    background: #ffffff;
    width: 960px;
    border-radius: 15px;
    opacity: 0;
    transform: translateX(-20%);
    animation: downAnim 0.2s ease-out 0.2s;
    animation-fill-mode: forwards;

    .name {
      font-size: 26px;
      line-height: 1.4237;
      font-weight: bold;
      margin-bottom: 6px;
    }

    .content {
      box-sizing: border-box;
      max-height: 424px;
      overflow-y: auto;
      border-top: 1px solid #EEEEEE;
      margin-top: 20px;
      margin-bottom: 50px;
      padding-top: 30px;
      padding-right: 20px;
      color: #333;

      &::-webkit-scrollbar {
        width: 3px;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 3px;
        background: #EEEEEE;
      }

      .title {
        position: relative;
        padding-left: 13px;
        font-weight: bold;
        margin-bottom: 10px;

        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          height: 14px;
          margin-top: -6px;
          width: 5px;
          background: #3ED8C4;
        }
      }

      ul {
        font-size: 14px;
        line-height: 2;
        padding-bottom: 30px;
      }
    }

    .btn {
      width: 130px;
      height: 44px;
      line-height: 44px;
      font-size: 14px;
      margin-left: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/content/children/joinUs.vue